import React from 'react';
import { HeaderFilterTable } from '@/components/common';

interface Props {
	search?: string;
	setSearch?: (value: string) => void;
	disabled?: boolean;
}

export const ClientFilterPayment: React.FC<Props> = ({
	search,
	setSearch,
	disabled,
}) => {
	const handleClearAll = () => setSearch && setSearch('');

	return (
		<HeaderFilterTable
			disabled={disabled}
			title="Client Name"
			searchTitle="Client Name"
			filterOptions={[]}
			isSearch={true}
			handleSearch={(value) => setSearch && setSearch(value)}
			isLoading={false}
			classNamePopoverContent="lg:!w-[345px]"
			handleClearAll={handleClearAll}
			hasFilter={!!search}
			classNameCommandGroup="flex flex-col-reverse"
		/>
	);
};
